import React, { useEffect, useState, FC, ChangeEventHandler } from 'react';
import { styled } from '@material-ui/core';
import SearchBox from '@/components/SearchBox';
import { SearchService } from '@/services/api/search-service';
import { theme } from '@/theme/mui-theme';
import { SearchResult } from '@/services/api/entities';
import SidebarSearchResult from './SidebarSearchResult';

const StyledContainer = styled('div')({
  display: 'grid',
  rowGap: theme.spacing(2)
});

const SidebarSearch : FC = () => {
  const searchService = new SearchService();
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchTimer, setSearchTimer] = useState<number>();
  const [hasData, setHasData] = useState(false);

  const [data, setData] = useState<SearchResult>({
    customers: [],
    reservations: []
  });

  const onChange : ChangeEventHandler<HTMLInputElement> = (event) => {
    const searchText = event.target.value;

    setInput(searchText);
  };

  function resetData() : void {
    setData({
      customers: [],
      reservations: []
    });
  }

  useEffect(() => {
    if (input !== '') {
      setLoading(true);
      resetData();

      const abortController = new AbortController();

      const timer = window.setTimeout(async () => {
        try {
          const searchPromise = searchService.find({
            abortSignal: abortController.signal,
            text: input,
            expand: ['customer', 'property']
          });

          const searchResult = await searchPromise;

          setData(searchResult);
          setHasData(true);
          setLoading(false);
        } catch (error) {
          console.error('Sidebar search failed', error);
        }
      }, 500);

      setSearchTimer(timer);

      return () => {
        window.clearTimeout(searchTimer);

        abortController.abort();
      };
    } else {
      setHasData(false);
      setLoading(false);
      resetData();
    }
  }, [input]);

  return (
    <StyledContainer>
      <SearchBox
        name="fieldSearch"
        placeholder="Search Guest or Reservation"
        searchKeyword={input}
        onSearch={onChange}
        loading={loading}
      />

      <SidebarSearchResult
        customers={data.customers}
        reservations={data.reservations}
        hasData={hasData}
      />
    </StyledContainer>
  );
};

export default SidebarSearch;
